// extracted by mini-css-extract-plugin
export default {"root":"_7kt_9","expanded":"_3EOYu"};